import { render, staticRenderFns } from "./PreviewCredential.vue?vue&type=template&id=0c1bb85a&scoped=true&"
import script from "./PreviewCredential.vue?vue&type=script&lang=js&"
export * from "./PreviewCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1bb85a",
  null
  
)

export default component.exports